export const formatDateBg = dateString => {
  if (!dateString) return "";

  const date = new Date(dateString);

  return new Intl.DateTimeFormat("bg-BG", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
};

export const formatDateOnlyBg = dateString => {
  if (!dateString) return "—";

  return new Intl.DateTimeFormat("bg-BG").format(new Date(dateString));
};
